import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import TreeForm from "components/agro/trees/TreeForm";
import { updateTree } from "graphql/mutations";
import { getTree } from "graphql/queries";

const TreeUpdateForm = ({ treeId, onSuccess }) => {
  const [tree, setTree] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        companyID,
      } = valuesParam;

      await API.graphql({
        query: updateTree.replaceAll("__typename", ""),
        variables: {
          input: {
            id: treeId,
            name,
            companyID,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(strings.responses.errorUpdate);
      console.error(err);
    }
  }

  async function fetchTree(id) {
    try {
      const treeData = await API.graphql(graphqlOperation(getTree, { id }));
      const treeItem = treeData.data.getTree;
      if (!treeItem) {
        toast.error(strings.responses.errorFetch);
        return;
      }
      setTree({
        ...treeItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchTree(treeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeId]);

  if (!tree) return <Loader />;

  return (
    <div>
      <TreeForm onSubmit={onSubmit} type="update" initialValues={tree} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    successUpdated: "Árbol actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el árbol",
      errorUpdate: "Error al actualizar árbol",
    },
  },
});

export default TreeUpdateForm;
